// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Inwd1","wrapper":"modal_wrapper__5359e"};